import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {} from "../../store/actions";

import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

import SideBarContentInstructor from "./SideBarContentInstructor";
import SidebarContent from "./SidebarContent";
import SidebarContentSuperAdmin from "./SidebarContentSuperAdmin";

import logo from "../../assets/images/logo.svg";
import logoLightPng from "../../assets/images/menuLogo.png";
import logoDark from "../../assets/images/logo-dark.png";
import SideBarClubLeader from "./SideBarClubLeader";

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const role = localStorage.getItem("roleId");
    return (
      <React.Fragment>
        <div style={{ backgroundColor: "#032224" }} className="vertical-menu">
          <div
            style={{ backgroundColor: "#032224" }}
            className="navbar-brand-box"
          >
            <Link to="/" className="logo logo-dark">
              {/* <span className="logo-sm">
                <img src={logo} alt="" height="22" />
              </span>
              <span className="logo-lg">
                <img src={logoDark} alt="" height="17" />
              </span> */}
            </Link>

            <Link to="/" className="logo logo-light">
              <span className="logo-lg">
                <img src={logoLightPng} alt="" height="35" />
              </span>
            </Link>
          </div>

          <div data-simplebar className="h-100">
            {
              role == 4 ? ( <SideBarContentInstructor />) : 
              (role == 666 || role == 10) ? (<SidebarContentSuperAdmin />) : 
              role == 5 ? (<SideBarClubLeader />) : ( <SidebarContent />)
            }
          </div>

          <div className="sidebar-background"></div>
        </div>
      </React.Fragment>
    );
  }
}

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  };
};
export default connect(
  mapStateToProps,
  {}
)(withRouter(withTranslation()(Sidebar)));
